import React from 'react';
import { observer } from 'mobx-react';
import { ConnectionTemplateConnectionGroupFormVM } from './connection-template-connection-group-form.viewmodel';
import { CommonPopupBodyFooterLayout } from '../../../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../../../global/sub-window/common/common-close-sub-window-buttons';
import { CANCEL_TEXT, MORE_BUTTON_TEXT, submitText } from '../../../../../../constants/common-labels.constants';
import { ConnectionTemplateConnectionGroupFieldKey, FORM_CONFIG } from './connection-template-connection-group-form.config';
import { FormFieldInput } from '../../../../../global/form/form-field-input/form-field-input';
import OptionsButton from '../../../../../global/options-button/options-button';
import { FormattedMessage } from 'react-intl';
import { CONNECTION_GROUP_CONNECTIONS_LABEL_TEXT, DELETE_CONNECTION_GROUP_TEXT } from '../../../../../_events/_manage-event/shared/connection-groups-list/connection-groups.texts';
import { ConnectionTemplateConnectionGroupConnectionsList } from './connection-group-connections-list/connection-template-connection-group-connections-list';
import '../../../../../_events/_manage-event/shared/connection-groups-list/connection-group-from/connection-group-form.scss';
import { PassportDisplayHeader } from '../../../../../_events/_manage-event/shared/configure-passport-display/passport-display-header';
import { ConnectionGroupPassportPreviewPopover } from '../../../../../_events/_manage-event/shared/connection-groups-list/connection-groups-passport-preview/connection-group-passport-preview-popover';

export type ConnectionTemplateConnectionGroupFormPresentationProps = {
    vm: ConnectionTemplateConnectionGroupFormVM;
};

export const ConnectionTemplateConnectionGroupFormPresentation = observer((props: ConnectionTemplateConnectionGroupFormPresentationProps) => {
    const { vm } = props;
    const labelField = vm.getFormFieldPropsByKey(ConnectionTemplateConnectionGroupFieldKey.LABEL);
    const isEdit = vm.isEdit();
    const connectionGroupsPassportPreviewViewModel = vm.getConnectionGroupsPassportPreviewViewModel();

    const groupOptions = [
        {
            label: vm.intl.formatMessage(DELETE_CONNECTION_GROUP_TEXT),
            action: () => vm.onDeleteGroupAction(vm.group.meetingConnectionId),
            danger: true
        }
    ];

    return (
        <CommonPopupBodyFooterLayout
            body={
                <>
                <PassportDisplayHeader
                    connectionLabel={connectionGroupsPassportPreviewViewModel.getPopoverTitle()}
                    onClickPreview={connectionGroupsPassportPreviewViewModel.openPopover}
                    disabled={connectionGroupsPassportPreviewViewModel.getIsPreviewDisabled()}
                />
                <form className='oe-form connection-group-form'>
                    <div className='oe-form__body'>
                        <FormFieldInput.Text
                            field={labelField}
                            labelDescriptor={FORM_CONFIG[ConnectionTemplateConnectionGroupFieldKey.LABEL].labelDescriptor}
                            withError
                        />
                        <div className='connection-group-form__connections'>
                            <div className='oe-form-field__title'>{vm.intl.formatMessage(CONNECTION_GROUP_CONNECTIONS_LABEL_TEXT)}</div>
                            <ConnectionTemplateConnectionGroupConnectionsList
                                enabledConnections={vm.getEnabledConnections()}
                                disabledConnections={vm.getDisabledConnections()}
                                enableConnection={vm.enableConnection}
                                disableConnection={vm.disableConnection}
                                onReorder={vm.setEnabledConnections}
                                maxEnabledConnections={vm.maxEnabledConnections}
                            />
                        </div>
                    </div>
                    <ConnectionGroupPassportPreviewPopover vm={connectionGroupsPassportPreviewViewModel} />
                </form>
                </>
            }
            footer={
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultCloseSubWindowButton
                        text={submitText(isEdit)}
                        modifier={['fat', 'confirm-safe']}
                        onClick={vm.submitForm}
                    />
                    <DefaultCloseSubWindowButton
                        text={vm.intl.formatMessage(CANCEL_TEXT)}
                    />
                    {isEdit &&
                        <OptionsButton
                            className='options-button--right-margin-auto'
                            modifier={['fat', 'options']}
                            label={<FormattedMessage {...MORE_BUTTON_TEXT} />}
                            options={groupOptions}
                            position='top'
                            align='start'
                        />
                    }
                </div>
            }
        />
    );
});
